import React from "react";
import {Edit,useRecordContext,required,FormDataConsumer,FunctionField,SimpleForm,TextInput,TextField, Toolbar, ListButton,SaveButton,} from "react-admin";

import { InfluencerStatusSelectInput } from "../../UI/Input/SelectInput";
import { RichTextInput } from 'ra-input-rich-text';

import Grid from "@material-ui/core/Grid";


const PageTitle = () => {
  const record = useRecordContext();
  return <span>Raise Ticket for {record ? `${record.profile_id}` : ''}</span>;
};
const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};
const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="list" submitOnEnter={true} />
    {!props.saving && <ListButton label="Cancel" />}
  </Toolbar>
);

const InfluencerBusinessRequestEdit = (props) => {
  
  return (
    <Edit title={<PageTitle />} {...props} undoable={false}>
      <SimpleForm warnWhenUnsavedChanges toolbar={<FormToolbar />}  redirect="list" defaultValues={{ action: "full" }}>       
          <SanitizedGrid container spacing={2} fullWidth>
            <Grid item sm={12} lg={4}>
              <TextInput disabled label="Profile ID" source="profile_id" fullWidth />
            </Grid>
              <Grid item sm={12}  lg={4}>
                <TextInput disabled source="email" label="Email" fullWidth/>
            </Grid>
            <Grid item sm={12}  lg={4}>
               <TextInput disabled source="name" label="Name" fullWidth/>
            </Grid>
          </SanitizedGrid>
          <SanitizedGrid container spacing={2} fullWidth>
            <Grid item sm={12} lg={4}>
              <TextInput disabled label="Form Type" source="form_type" fullWidth />
            </Grid>
              <Grid item sm={12}  lg={4}>
                <TextInput disabled source="telegram_id" label="Telegram ID" fullWidth/>
            </Grid>
            <Grid item sm={12}  lg={4}>
               <TextInput disabled source="phone" label="Phone" fullWidth/>
            </Grid>
          </SanitizedGrid>
          
           <SanitizedGrid container spacing={2} fullWidth>
            <Grid item sm={12} lg={4}>
              <TextInput disabled label="Title" source="title" fullWidth />
            </Grid>
              <Grid item sm={12}  lg={4}>
                <TextInput disabled source="description" label="Description" fullWidth/>
            </Grid>
            <Grid item sm={12}  lg={4}>
               <TextInput disabled source="agree_to_continue" label="Agree to Continue" fullWidth/>
            </Grid>
          </SanitizedGrid>

           <SanitizedGrid container spacing={2} fullWidth>
            <Grid item sm={12} lg={4}>
              <TextInput disabled label="Pre-Team Type" source="pre_team_type" fullWidth />
            </Grid>
          </SanitizedGrid>
          <SanitizedGrid container spacing={3} fullWidth>
           
           
            <Grid item sm={12}  lg={6}>
          <TextInput  label="Commends" source="commends" fullWidth validate={required()} />
            </Grid>     
           
          </SanitizedGrid>
          
      </SimpleForm>
    </Edit>
  );
};

export default InfluencerBusinessRequestEdit;
